import { isValidElement, type ComponentType, type ReactNode } from 'react';
import { matchRoutes, type RouteObject } from 'react-router-dom';

interface RouteLike {
  path: string;
  element?: ReactNode;
  children?: RouteLike[];
  isPublic?: boolean;
}

/**
 * Whether the route config renders `page` at this path. Routes are nested as
 * App mounts them: public ones at the root, private ones under `:tenantSlug`.
 */
export function routeRendersPage(
  pathname: string,
  routes: RouteLike[],
  page: ComponentType
): boolean {
  const tree: RouteObject[] = [
    ...routes.filter((route) => route.isPublic),
    {
      path: ':tenantSlug',
      children: routes.filter((route) => !route.isPublic),
    },
  ];
  const matches = matchRoutes(tree, pathname);
  const element = matches?.[matches.length - 1]?.route.element;
  return isValidElement(element) && element.type === page;
}
